// src/serviceWorkerRegistration.js
/* eslint-disable no-console */

async function tryRegister(path) {
  try {
    const head = await fetch(path, { method: "HEAD" });
    if (!head.ok) {
      console.warn(`[SW] ${path} not found (${head.status}).`);
      return null;
    }
    const registration = await navigator.serviceWorker.register(path, {
      // Always re-check for SW updates on every page load
      updateViaCache: "none",
    });

    // Check for updates immediately and every 30 min
    registration.update();
    setInterval(() => registration.update(), 30 * 60 * 1000);

    registration.addEventListener("updatefound", () => {
      const newWorker = registration.installing;
      if (!newWorker) return;
      newWorker.addEventListener("statechange", () => {
        // When a new SW is installed and waiting, reload to activate it
        if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
          console.info("[SW] Nueva versión disponible — recargando.");
          // Give the page 2s to finish any pending work then reload
          setTimeout(() => window.location.reload(), 2000);
        }
      });
    });

    return registration;
  } catch (err) {
    console.error(`[SW] Error al registrar ${path}:`, err);
    return null;
  }
}

export async function register() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    tryRegister("/sw_qkiere.js");
  });
}

export async function unregisterAll() {
  const regs = await navigator.serviceWorker.getRegistrations();
  for (const reg of regs) await reg.unregister();
}
